if (!window.customElements.get("product-size-selector")) {
  class ProductSizeSelector extends HTMLElement {
    constructor() {
      super();

      // Elements
      this.sizeButtons = this.querySelectorAll("button");
      this.selectElement = this.querySelector("select");
      this.summary = this.querySelector("summary span");
      this.deliveryNote =
        document.getElementById("delivery-note") ||
        this.querySelector(".swatch-title__note");

      // Initialize
      this.init();
    }

    init() {
      // Set initial active state based on select value
      this.updateActiveButton();

      // Update delivery note for initial state (usually default size)
      this.updateDeliveryNote();

      // Add event listeners to buttons
      this.sizeButtons.forEach((button) => {
        button.addEventListener("click", this.handleButtonClick.bind(this));
      });

      // Add event listener to select
      this.selectElement.addEventListener(
        "change",
        this.handleSelectChange.bind(this)
      );
    }

    handleButtonClick(event) {
      const button = event.currentTarget;
      const value = button.getAttribute("value");

      // Update select value
      this.selectElement.value = value;

      // Trigger change event on select to ensure any other listeners are notified
      this.selectElement.dispatchEvent(new Event("change"));

      // Update active state
      this.updateActiveButton();

      // Update delivery note
      this.updateDeliveryNote();

      // Close the details element
      const details = this.querySelector("details");
      if (details) details.removeAttribute("open");
    }

    handleSelectChange(event) {
      const value = this.selectElement.value;

      // Update summary text
      if (this.summary) {
        this.summary.textContent = value;
      }

      // Update active button
      this.updateActiveButton();

      // Update delivery note
      this.updateDeliveryNote();
    }

    updateActiveButton() {
      const currentValue = this.selectElement.value;

      // Remove active class from all buttons
      this.sizeButtons.forEach((button) => {
        button.classList.remove("active");
      });

      // Add active class to matching button
      this.sizeButtons.forEach((button) => {
        if (button.getAttribute("value") === currentValue) {
          button.classList.add("active");
        }
      });
    }

    updateDeliveryNote() {
      if (!this.deliveryNote) return;
      const defaultSize = this.dataset.defaultSize?.toLowerCase().trim() || "";
      const currentSize = this.selectElement.value?.toLowerCase().trim() || "";

      if (defaultSize === currentSize) {
        this.deliveryNote.textContent = "Next-day delivery available";
      } else {
        this.deliveryNote.textContent = "+2 working days (delivery in 3-4 working days)";
      }
    }
  }

  customElements.define("product-size-selector", ProductSizeSelector);
}
